import 'promise-polyfill/src/polyfill';
import Vue from 'vue'
import store from './store'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import routes from './js/Routes';
import VStyle from './js/VStyle';
import FontAwesomeIcon from './js/ConfigureFontAwesome.js'
import './css/custom.scss'
import * as VueGoogleMaps from 'vue2-google-maps'
import VeeValidate from 'vee-validate';
import VueAlertify from 'vue-alertify';
import { i18n } from './js/i18n.js'
import Utils from './js/Utils'
import VueGtag from "vue-gtag";


Vue.component('v-style', VStyle);
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueGtag, { bootstrap: false });
Vue.use(BootstrapVue)
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GMAPS_KEY,
  }
});
Vue.use(VeeValidate);
Vue.use(VueAlertify);

Vue.config.productionTip = false
Vue.http.options.root = process.env.VUE_APP_BT_API

const router = new VueRouter({routes})

const v = new Vue({
	router,
  store,
  i18n,
	render: h => h(App)
}).$mount('#app')

Vue.config.errorHandler = (err) => {
  const code = Utils.reportLog(v, err);
  v.$alertify.alert("Error", `Please try again latter <br> ErrorCode: ${code}`);
}
